<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>File</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              File
            </div>
          </div>
        </div>

        <div class="section-body">
          <div class="card">
            <div class="card-header">
              <h4 class="d-inline">
                File
              </h4>
            </div>
            <div
              class="card-body"
              style="overflow:hidden"
            >
              <ul>
                <li
                  v-for="(f, i) in file"
                  :key="f.path + '-' + i"
                >
                  {{ f.path }}
                  <ul>
                    <li
                      v-for="d in f.file"
                      :key="d.name"
                    >
                      <a
                        v-b-tooltip
                        :href="$store.getters.getBaseUrl + '/api/file/' + f.path + '/' + d.name"
                        target="_blank"
                        :title="d.timestamp"
                      >{{ d.name }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from './../layouts/Admin.vue'
import NProgress from 'nprogress'
import swal from 'sweetalert'

export default {
  name: 'File',
  data() {
    return {
      file: null
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  components: {
    LayoutAdmin
  },
  methods: {
    fetchAllFiles () {
      this.$store.dispatch('fetchAllFiles').then((res) => {
        if(res.data.status){
          this.file = res.data.data
        }
      })
    }
  },
  mounted() {
    this.fetchAllFiles()
  }
}
</script>